module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f7f8fa"
    }
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('repair_title'),
      "url": "/fangT"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "orderSta clearfix"
  }, [_c('div', {
    staticClass: "Num"
  }, [_vm._v(_vm._s(_vm.orderInfo.rmno))]), _vm._v(" "), _c('div', {
    staticClass: "sta"
  }, [(_vm.orderInfo.chg_sta == 'S') ? _c('span', {
    staticStyle: {
      "color": "#D0011B"
    }
  }, [_vm._v(_vm._s(_vm.$t('repair_staS')))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.chg_sta == 'O') ? _c('span', {
    staticStyle: {
      "color": "#D0011B"
    }
  }, [_vm._v(_vm._s(_vm.$t('repair_staO')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "infoList"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\n\n          " + _vm._s(_vm.$t('fangTXQ_baseInfo')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent "
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_rmno')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.rmno))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('orderDetail_sta')) + ":\n            "), (_vm.orderInfo.chg_sta == 'S') ? _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.$t('repair_staS')))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.chg_sta == 'O') ? _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.$t('repair_staO')))]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('repair_begin')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("datefomate")(_vm.orderInfo.date_begin)))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('repair_end')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm._f("datefomate")(_vm.orderInfo.date_end)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v("\n          " + _vm._s(_vm.$t('other')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('reason')) + ":"), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.weixiu_reason))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$t('book_remark')) + ":\n            "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.orderInfo.remark))]), _vm._v(" "), (_vm.showEditWeixiuRemark) ? _c('span', {
    staticClass: "iconfont icon-xiugai",
    staticStyle: {
      "color": "orange",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.openModal
    }
  }) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "updateRemark-special"
  }, [_c('mt-popup', {
    staticClass: "guestInfo-modal",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('updateRemark_title')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarkNew),
      expression: "remarkNew"
    }],
    staticClass: "remark",
    attrs: {
      "placeholder": _vm.$t('placeHolder_Empty')
    },
    domProps: {
      "value": (_vm.remarkNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarkNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4c429030","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/repair.vue
// module id = 1784
// module chunks = 107